namespace TabAurous.Production {
    export interface WIPTransactionRow {
        StockId?: number;
        TransId?: number;
        MovementId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        VoucherDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        DeptName?: string;
        ProcessId?: number;
        EmployeeId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SubBagNo?: number;
        SKU?: string;
        LotNo?: string;
        RefNo?: string;
        GroupId?: string;
        ItemTypeId?: number;
        HSN?: string;
        TaxCode?: string;
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        AttributeId?: number;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        Rate?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        IsCustomerItem?: boolean;
        CalcOnId?: number;
        CostMethodId?: number;
        ImageName?: string;
        CompanyId?: number;
        FinancialYearId?: number;
        Purity?: number;
        PureWeight?: number;
        Attribute?: string;
        ProductTypeId?: number;
        StoneColorId?: number;
        MetalColorId?: number;
        QualityId?: number;
        KaratId?: number;
        ShapeId?: number;
        StoneSizeId?: number;
        SieveId?: number;
        SettingId?: number;
        SettingName?: string;
        StoneStatusId?: number;
        StoneStatusName?: string;
        Lab?: string;
        CertificateNo?: string;
        StoneSizeName?: string;
        SieveName?: string;
        StoneColoreName?: string;
        QualityName?: string;
        ShapeName?: string;
        MetalColorName?: string;
        KaratName?: string;
        CategoryId?: number;
    }

    export namespace WIPTransactionRow {
        export const idProperty = 'StockId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Production.WIPTransaction';
        export const lookupKey = 'Production.WIPTransaction';

        export function getLookup(): Q.Lookup<WIPTransactionRow> {
            return Q.getLookup<WIPTransactionRow>('Production.WIPTransaction');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            StockId = "StockId",
            TransId = "TransId",
            MovementId = "MovementId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            VoucherDate = "VoucherDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            DeptName = "DeptName",
            ProcessId = "ProcessId",
            EmployeeId = "EmployeeId",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SubBagNo = "SubBagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            RefNo = "RefNo",
            GroupId = "GroupId",
            ItemTypeId = "ItemTypeId",
            HSN = "HSN",
            TaxCode = "TaxCode",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            AttributeId = "AttributeId",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            Rate = "Rate",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            IsCustomerItem = "IsCustomerItem",
            CalcOnId = "CalcOnId",
            CostMethodId = "CostMethodId",
            ImageName = "ImageName",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            Purity = "Purity",
            PureWeight = "PureWeight",
            Attribute = "Attribute",
            ProductTypeId = "ProductTypeId",
            StoneColorId = "StoneColorId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            KaratId = "KaratId",
            ShapeId = "ShapeId",
            StoneSizeId = "StoneSizeId",
            SieveId = "SieveId",
            SettingId = "SettingId",
            SettingName = "SettingName",
            StoneStatusId = "StoneStatusId",
            StoneStatusName = "StoneStatusName",
            Lab = "Lab",
            CertificateNo = "CertificateNo",
            StoneSizeName = "StoneSizeName",
            SieveName = "SieveName",
            StoneColoreName = "StoneColoreName",
            QualityName = "QualityName",
            ShapeName = "ShapeName",
            MetalColorName = "MetalColorName",
            KaratName = "KaratName",
            CategoryId = "CategoryId"
        }
    }
}
